import type { JSX , ElementType } from "react";
import type { ChildrenProp, ClassNameProp } from "@charterindex/armoury-www";
import { Box } from "@mui/material";


export type ContentWidthProps = ClassNameProp & Required<ChildrenProp> & {
	component?: ElementType;
	narrow?: boolean;
};
export const ContentWidth = ({ component, className, narrow, children }: ContentWidthProps): JSX.Element => (
	<Box
		component={ component ?? "div" }
		className={ className }
		sx={ theme => ({
			width: "100%",
			maxWidth: narrow
				? theme.layout.contentNarrowMaxWidth
				: theme.layout.contentMaxWidth,
		}) }
	>
		{ children }
	</Box>
);
